import React from "react";
import EventCard from "./EventCard";

const MobileAgendaView = ({ currentDate, events, onEventClick }) => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const today = new Date();

    const getDateKey = (date) => {
        const localDate = new Date(date);
        if (Number.isNaN(localDate.getTime())) return null;
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, "0");
        const day = String(localDate.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    // Get all dates with events in chronological order
    const getDatesWithEvents = () => {
        const datesWithEvents = [];

        // Get all dates in the current month
        const lastDay = new Date(year, month + 1, 0);
        const daysInMonth = lastDay.getDate();

        for (let day = 1; day <= daysInMonth; day++) {
            const dateKey = getDateKey(new Date(year, month, day));
            const dateEvents = (dateKey && events[dateKey]) ? events[dateKey] : [];

            if (dateEvents.length > 0) {
                datesWithEvents.push({
                    day,
                    dateKey,
                    date: new Date(year, month, day),
                    events: dateEvents,
                });
            }
        }

        return datesWithEvents.sort((a, b) => a.day - b.day);
    };

    const getDayName = (date) => {
        return date.toLocaleDateString("en-US", { weekday: "short" });
    };

    const getFormattedDate = (date) => {
        return date.toLocaleDateString("en-US", {
            month: "short",
            year: "numeric"
        });
    };

    const isToday = (date) => {
        return (
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear()
        );
    };

    const datesWithEvents = getDatesWithEvents();

    if (datesWithEvents.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-12 px-4">
                <p className="text-lg font-semibold text-navy-700 dark:text-white mb-2">
                    No scheduled calls
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
                    No events scheduled for {currentDate.toLocaleDateString("en-US", { month: "long", year: "numeric" })}
                </p>
            </div>
        );
    }

    return (
        <div className="space-y-3">
            {datesWithEvents.map((dateData) => {
                const dateIsToday = isToday(dateData.date);

                return (
                    <div
                        key={dateData.dateKey}
                        className={`rounded-lg border-2 p-4 transition-all duration-200 ${dateIsToday
                                ? "bg-brand-500/5 border-brand-500"
                                : "bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700"
                            }`}
                    >
                        {/* Date Header */}
                        <div className="flex items-center justify-between mb-3">
                            <div className="flex items-center gap-3">
                                <div
                                    className={`inline-flex items-center justify-center w-10 h-10 rounded-full text-base font-bold ${dateIsToday
                                            ? "bg-brand-500 text-white"
                                            : "bg-gray-200 dark:bg-gray-700 text-navy-700 dark:text-white"
                                        }`}
                                >
                                    {dateData.day}
                                </div>
                                <div>
                                    <p className="font-semibold text-navy-700 dark:text-white">
                                        {getDayName(dateData.date)}
                                    </p>
                                    <p className="text-xs text-gray-600 dark:text-gray-400">
                                        {getFormattedDate(dateData.date)}
                                    </p>
                                </div>
                            </div>
                            {dateIsToday && (
                                <span className="px-2 py-1 bg-brand-500 text-white text-xs font-semibold rounded-full">
                                    Today
                                </span>
                            )}
                        </div>

                        {/* Events for this date */}
                        <div className="space-y-2 ml-14">
                            {dateData.events.map((event) => (
                                <EventCard
                                    key={event.id}
                                    event={event}
                                    onClick={() => onEventClick(event)}
                                    isMobile
                                />
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default MobileAgendaView;
